import styled from 'styled-components'

export const ErrorText = styled.p`
  color: #d24444ff;
`
